import { Dialog } from './dialog';
import { Button } from "primereact/button";
import { MarkdownText } from '../markdown-text';

interface InstructionsDialogProps {
    visible: boolean;
    onHide: () => void;
    instructions: string | string[];
    parent: HTMLDivElement | null;
}

export function InstructionsDialog({ visible, onHide, instructions, parent }: InstructionsDialogProps) {
    return (
        <Dialog
            header="Instructions"
            visible={visible}
            onHide={onHide}
            style={{ width: 'min(48rem, calc(100vw - 2rem))', height: 'min(42rem, calc(100dvh - 2rem))' }}
            modal
            appendTo={parent}
            draggable={false}
            resizable={false}
        >
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    minHeight: 0
                }}
            >
                <div
                    style={{
                        flex: 1,
                        minHeight: 0,
                        overflowY: "auto",
                        padding: "0.75rem",
                        // whiteSpace: "pre-wrap",
                        fontSize: "0.9rem",
                        background: "var(--surface-ground)",
                        border: "1px solid var(--surface-border)",
                        borderRadius: "4px"
                    }}
                >
                    {(Array.isArray(instructions) ? instructions : [instructions]).map((text, index) =>
                        <MarkdownText key={index} text={text} legacyHtml className={index ? 'mt-4 pt-4 border-top-1 surface-border' : ''} />)}
                </div>


                <div style={{ marginTop: "1rem", textAlign: "right" }}>
                    <Button label="Close" icon="pi pi-times" onClick={onHide} />
                </div>
            </div>
        </Dialog>
    );
}
